const env = process.env;

export const THEME = env.REACT_APP_THEME || 'green';
export const LANGUAGE = env.REACT_APP_LANGUAGE || 'ru';
export const WON_BONUSES = env.REACT_APP_WON_BONUSES || '[]';
